<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>Support</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>Have questions? Need some support?</p>
        <p>Give us a call! (612) 655-2324</p>
        <p>Email support@yarlow.com</p><!-- TODO: Adjust these to be better lined -->
        <p>Feel free to start a chat with us! Click the link in the lower right corner.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$global.gaEvent('realtorViewSupport', 'navigation')
  }
}
</script>

<style scoped>
.bold-text {
  font-weight: bold;
  margin-bottom: 0;
}

.btn {
  margin-top: 0px !important;
}

.container {
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.price {
  font-size: 1.5rem;
}

.product {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 10px;
}

.small-bottom-margin {
  margin-bottom: 1.5rem;
}

.sub-header {
  margin-bottom: 0;
  margin-top: 2rem;
}

.top-margin {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/realtorProfile/RealtorSupport.vue